import { Roles } from 'Src/constants/Roles'

export const UnsignedOrdersRoles = [Roles.MANAGER, Roles.HEAD_MANAGER, Roles.RUKOVODITEL]
export const StatusDescRoles = [
	Roles.TERMEN,
	Roles.REGMEN,
	Roles.SENIOR_MANAGER,
	Roles.HEAD_SECTOR,
	Roles.HEAD_GOVERNANCE,
	Roles.PRODUCT_SPECIALIST,
]
